import { ISwAppTransactionsApi } from "../../interfaces-and-types";

type TTransactionsUrls = {
  [key in keyof ISwAppTransactionsApi]: string;
};

const rootTransactionsUrl = "/transactions";

const rootTopUpsUrl = "/top-ups";
const rootTopUpTransactionsUrl = "/topup-transactions";

export const transactionsUrls: TTransactionsUrls = {
  initClientSideTransaction: `${rootTransactionsUrl}/init-transaction`,
  getTransactions: `${rootTransactionsUrl}`,
  getTransactionById: `${rootTransactionsUrl}/id`,
  getTransactionByRef: `${rootTransactionsUrl}/reference`,

  // events
  // cancelTransactionByRef: `${rootTransactionsUrl}/cancel`,
  // sendCheckoutLoadedEvent: `${rootTransactionsUrl}/events/checkout-loaded`,
  sendCheckoutClosedEvent: `${rootTransactionsUrl}/events/checkout-closed`,
  // sendGatewayInitializedEvent: `${rootTransactionsUrl}/events/provider-initialized`,
  // // sendGatewayReinitializedEvent: `${rootTransactionsUrl}/events/provider-initialized`,
  // sendCheckoutPaymentCompletedEvent: `${rootTransactionsUrl}/events/checkout-closed`,

  // payment link txs
  initVirtualBankAccTransaction: `/payment-link-transactions/virtual-transfer-payment`,
  initPaymentLinkGatewayTransaction: `/payment-link-transactions/gateway-payment`,
  initPaymentLinkDirectCardChargeTransaction: `/payment-link-transactions/card-payment`,

  checkVirtualTransferTransactionStatus: `/transactions/check-virtual-transfer-status`,
  resendTxWebhookByRef: `/transactions/resend-webhook-by-ref`,
  resendTxWebhookById: `/transactions/resend-webhook-by-id`,
  getCheckoutTotal: `/payment-link-transactions/checkout-fees`,

  // top-up txs
  createTopUp: `${rootTopUpsUrl}/initialize`, // this is a tx-init
  getTopUps: `${rootTopUpsUrl}`,
  getTopUpById: `${rootTopUpsUrl}/id`,

  initTopUpGatewayTransaction: `${rootTopUpTransactionsUrl}/gateway-topup`,
  initTopUpDirectCardChargeTransaction: `${rootTopUpTransactionsUrl}/card-topup`,
  initTopUpVirtualBankAccTransaction: `${rootTopUpTransactionsUrl}/virtual-transfer-topup`,
};
